import { TokenSet } from 'openid-client';

export function saveTokenSetToLocalStorage(tokenSet: TokenSet) {
  localStorage.setItem('tokenSet', JSON.stringify(tokenSet));
}

export function loadTokenSetFromLocalStorage(): TokenSet | null {
  const tokenSetString = localStorage.getItem('tokenSet');
  if (tokenSetString) {
    return JSON.parse(tokenSetString) as TokenSet;
  }
  return null;
}

export function clearTokenSetFromLocalStorage() {
  localStorage.removeItem('tokenSet');
}
